export const isElectron = () => {
  return window.electronAPI?.electronPage || window.electronAPI?.singlePage;
};

export const electronRemoveSuffix = (url: string) => {
  if (!window.electronAPI) {
    return url;
  }
  return url.replace('-electron', '');
};

export const electronRemoveNameSuffix = (routeName: string) => {
  if (!window.electronAPI) {
    return routeName;
  }
  return routeName.replace('Electron', '');
};

export const electronDelTab = (tag: string) => {
  if (window.electronAPI?.singlePage) {
    window.electronAPI?.delTab(tag);
  }
};
